import { render } from "./UserInputForm.vue?vue&type=template&id=453166a3&scoped=true"
import script from "./UserInputForm.vue?vue&type=script&lang=js"
export * from "./UserInputForm.vue?vue&type=script&lang=js"

import "./UserInputForm.vue?vue&type=style&index=0&id=453166a3&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "453166a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453166a3', script)) {
    api.reload('453166a3', script)
  }
  
  module.hot.accept("./UserInputForm.vue?vue&type=template&id=453166a3&scoped=true", () => {
    api.rerender('453166a3', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/2/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453166a3"],['__file',"src/components/UserInputForm.vue"]])